import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Badge, Image } from "@chakra-ui/react";
import { IMG_URL } from "../common/Constant";
const MultiTag = ({ type, count = 0, vipLabel = "VIP", minLadiesReq = 0, tableShape = "", }) => {
    let bg = "";
    let color = "";
    let text = "";
    let icon = null;
    switch (type) {
        case "vip":
            bg = "#291D51";
            color = "#8155FE";
            text = vipLabel;
            icon = `${IMG_URL}/icons/crown-icon.svg`;
            break;
        case "addon":
            bg = "#1E3E44";
            color = "#00FFEA";
            text = `${count} Addons`;
            icon = `${IMG_URL}/icons/star-icon.svg`;
            break;
        case "fastFilling":
            bg = "#4B4629";
            color = "#FE9655";
            text = "Fast Filling";
            icon = null;
            break;
        case "minLadies":
            bg = "#2F2F2F";
            color = "#FFFFFF";
            text = `x ${minLadiesReq}`;
            icon = `${IMG_URL}/icons/female.svg`;
            break;
        case "tableShape":
            bg = "#244062ff";
            color = "#ffffffff";
            text = tableShape || "Shape";
            icon = null;
            break;
    }
    return (_jsxs(Badge, { bg: bg, color: color, px: 3, py: 1, borderRadius: "4px", display: "flex", alignItems: "center", gap: icon ? 2 : 0, fontSize: "10px", fontWeight: "500", h: "fit-content", w: "fit-content", children: [icon && (_jsx(Image, { src: icon, alt: text, boxSize: "12px", objectFit: "contain" })), text] }));
};
export default MultiTag;
